import { rankingMovies } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            本周热播榜
          </h2>
          <p className="text-sm text-foreground-600">
            热度与口碑兼具，影迷都在看的精选好片
          </p>
        </div>

        <div className="space-y-2">
          {rankingMovies.map((m) => (
            <div
              key={m.rank}
              className="flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl px-4 md:px-5 py-3 md:py-3.5 border border-background-200/70 hover:border-accent-200/50 transition-all duration-200 group cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                m.rank <= 3
                  ? 'bg-accent-500 text-background-950'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {m.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-medium text-sm md:text-base text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    {m.title}
                  </h3>
                  {m.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] md:text-xs font-medium whitespace-nowrap ${
                      m.tag === 'NEW' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-700'
                    }`}>
                      {m.tag}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-500">{m.genre}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{m.year}</span>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <span className="font-heading text-base md:text-lg font-bold text-accent-500">{m.score}</span>
                <span className="text-xs text-foreground-500">分</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}